import { Injectable } from "@angular/core";
import { AutomationRule } from "../interfaces/automation-rule.interface";
import { AutomationRuleDto } from "../interfaces/dto/automation-rule.dto";
import { WhatsappTemplateAdapter } from "./whatsapp-template.adapter";
import { MediaAdapter } from "./media.adapter";

@Injectable({
  providedIn: 'root'
})
export class AutomationRuleAdapter {
  constructor(private templateAdapter: WhatsappTemplateAdapter, private mediaAdapter: MediaAdapter) {}

  run(rule: AutomationRuleDto): AutomationRule {
    return {
      ...rule,
      productFollowupConfig: rule.productFollowupConfig ? {
        ...rule.productFollowupConfig,
        templateId: rule.productFollowupConfig.templateId,
        template: rule.productFollowupConfig.template ? this.templateAdapter.run(rule.productFollowupConfig.template) : null,
        mediaId: rule.productFollowupConfig.mediaId ?? undefined,
        media: rule.productFollowupConfig.media ? this.mediaAdapter.run(rule.productFollowupConfig.media) : null,
      } : undefined,
    };
  }
}
